<ng-template #header>
  <div class="mb-4" *ngIf="backButton">
    <app-button [text]="'<'" [matButtonAparence]="'tonal'" [href]="'/'+backUrl()" type="button"></app-button>
  </div>

</ng-template>
<ng-template #content>
    <app-titledescription [title]="'Editar '+title" [description]="description"></app-titledescription>
      @if(templateHeaderDescription){
        <ng-container *ngTemplateOutlet="templateHeaderDescription"></ng-container>
        <div class="divider my-2"></div>
      }
      <app-form #formGeneral [fields]="fields" [backUrl]="'/'+backUrl()" [isLoading]="isLoading" (selectFieldValueEmit)="selectFieldValueEmit.emit($event)"></app-form>
</ng-template>
<ng-template #actions>
  <div class="flex gap-2 mb-4 ml-4" *ngIf="actionButtons">
    <app-button text="Guardar" (click)="submit()"></app-button>
    <app-button (click)="navigateToBack()" text="Cancelar" [matButtonAparence]="'tonal'" type="button"></app-button>
  </div>
</ng-template>
<app-card [templateRefHeader]="header" [templateRefContent]="content" [templateRefFooter]="actions"></app-card>
